import React from 'react';
import {useSelector} from "react-redux";
import "./customTable.scss";
import numericFunction from "../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";

function CustomReviewAccountTable(props) {
  const data = useSelector(s => s.reviewAccountReducer)
  const myData = data.myData;
  console.log(myData)
  try {

    const fieldList = [];
    myData.column.forEach(v => {
      fieldList.push(v.field)
    })



    const sum = {
      sumBed: 0,
      sumBes: 0,
      sumBedRemaining: 0,
      sumBesRemaining: 0,
    }
    return (
      <div className={''}>
        {data?.myData?.data.length === 0 && <>
          <div
            style={{
              padding: 5,
              borderRadius: 5,
              border: "1px solid #B9B9B9",
              color: "#B9B9B9"
            }}>
            سطری برای نمایش وجود ندارد
          </div>
        </>}
        {data?.myData?.data.length > 0 &&
          <>
            <div className={'customTableReview'}>
              <div className={'table__14020614'}>
                <div className={'thead'}>
                  <ul>
                    {/*{myData.column.map(v => <th>{v.title}</th>)}*/}
                    <li className={'text-center'}>کد</li>
                    <li className={'text-center'}>عنوان</li>
                    <li className={'text-center'}>تاریخ سند</li>
                    <li className={'text-center'}>شماره سند</li>
                    <li className={'text-center'}>عطف</li>
                    <li className={'text-center'}>گردش بدهکار</li>
                    <li className={'text-center'}>گردش بستانکار</li>
                    <li className={'text-center'}>مانده بدهکار</li>
                    <li className={'text-center'}>مانده بستانکار</li>
                  </ul>

                </div>
                <div className={'tbody'}>

                  {/*myData.data.map((row, rowIndex) => {

            return <tr>{
              fieldList.map((v, fieldListIndex) => <td>{row[fieldList[fieldListIndex]]}</td>)
            }</tr>
          })*/}

                  {myData.data.map((row, rowIndex) => {

                    let level_2 = numericFunction.e2p(myData.data[rowIndex].level_2)
                    let level_3 = numericFunction.e2p(myData.data[rowIndex].level_3)
                    let level_4 = numericFunction.e2p(myData.data[rowIndex].level_4)
                    let name_2 = numericFunction.e2p(myData.data[rowIndex].name_2)
                    let name_3 = numericFunction.e2p(myData.data[rowIndex].name_3)
                    let name_4 = numericFunction.e2p(myData.data[rowIndex].name_4)
                    let date = numericFunction.e2p(myData.data[rowIndex].date)
                    let documentId = numericFunction.e2p(myData.data[rowIndex].documentId)
                    let documentNumber = (myData.data[rowIndex].documentNumber)
                    let description = numericFunction.e2p(myData.data[rowIndex].description)


                    let bed = formatToPersianAddComma(myData.data[rowIndex].bed)
                    let bes =formatToPersianAddComma(myData.data[rowIndex].bes)
                    let bedRemaining = formatToPersianAddComma(myData.data[rowIndex].bedRemaining)
                    let besRemaining = formatToPersianAddComma(myData.data[rowIndex].besRemaining)


                    // calculate sum
                    sum.sumBed += +myData.data[rowIndex].bed;
                    sum.sumBes += +myData.data[rowIndex].bes;
                    sum.sumBedRemaining += +myData.data[rowIndex].bedRemaining;
                    sum.sumBesRemaining += +myData.data[rowIndex].besRemaining;



                    return (
                      <ul>
                        <li> {level_3}<br/> {level_4}</li>
                        <li> {name_3}<br/> {name_4}</li>
                        <li>
                          <div className={'d-flex justify-content-around'}>
                            <div>{date}</div>
                            <div>{documentId}</div>
                            <div>{documentNumber}</div>
                          </div>
                          <div>{description}</div></li>


                        <li className={'text-center'}>{bed}</li>
                        <li className={'text-center'}>{bes}</li>
                        <li className={'text-center'}>{bedRemaining}</li>
                        <li className={'text-center'}>{besRemaining}</li>
                      </ul>
                    )
                  })}
                </div>
                <div className={'tfoot'}>
                  <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li>{formatToPersianAddComma(sum.sumBed)}</li>
                    <li>{formatToPersianAddComma(sum.sumBes)}</li>
                    <li>{formatToPersianAddComma(sum.sumBedRemaining)}</li>
                    <li>{formatToPersianAddComma(sum.sumBesRemaining)}</li>
                  </ul>
                </div>
              </div>
            </div>

          </>


        }

      </div>
    );
  } catch (err) {
    return <>{err.message}</>
  }

}

export default CustomReviewAccountTable;